angular.module('property-price-list')
    .service('PropertyPriceListImportService', function (modals) {
        this.import = (projectId, allAttributes) => {
            return modals.open('app/property-price-list/import-modal.html', 'PropertyPriceListImportController', { project: projectId, allAttributes: allAttributes }, {size: 'sm'}, "$ctrl");
        }
    })
    .controller('PropertyPriceListImportController', function ($cookies, $scope, data, $rootScope, $http, $uibModalInstance, toastr, FileUploader) {
        this.entityPathCsv = "/crm/api/property-price-list"
        this.types = ["CSV-SIMPLE-INITIAL", "CSV-SIMPLE"];

        this.import = {
            // type: "CSV-SIMPLE",
            charset: "UTF-8",
            project: data.project
        };
        this.data = [];

        function createUploader(entityPathCsv, importForm, responseDataFn) {
            let uploader = new FileUploader({
                url: entityPathCsv + '/import',
                autoUpload: true,
                headers: {
                    "X-Requested-With": 'XMLHttpRequest',
                    "X-CSRF-TOKEN": $cookies.get("CSRF-TOKEN")
                }
            });
            uploader.onSuccessItem = (fileItem, response, status, headers) => {
                toastr.success("Wczytano dane z pliku");
                responseDataFn(response);
                angular.element("input[type='file']").val(null);
            };
            uploader.onErrorItem = (fileItem, rejection, status, headers) => {
                if (angular.isArray(rejection.messages)) {
                    angular.forEach(rejection.messages, (message, key) => toastr.error(message));
                }
            };
            uploader.onBeforeUploadItem = item => item.formData.push(importForm);
            return uploader;
        }

        this.uploader = createUploader(this.entityPathCsv, this.import, response => {
            $uibModalInstance.close(response);
        });

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
    })
